import { Directive } from '@angular/core';

@Directive({
  selector: '[appDdlSelectedText]'
})
export class DdlSelectedTextDirective {

  constructor() { }

}
